/**
 * Which text lines a time block shows at a given height. Pure, so the boundaries
 * can be tested without a browser.
 *
 * Each line only appears once the block is tall enough to hold it whole. The
 * old thresholds (35 / 55 / 75 px) were smaller than the lines they guard (51,
 * 71 and 89 px with no border), so short blocks drew a line and cropped it. The
 * task-code line is always drawn. If `TimeBlock.css` font sizes, line heights,
 * margins, padding or borders change, re-measure.
 */

/**
 * Measured needs (Chromium, DM Sans, 4px vertical padding, 1px top and bottom
 * border): name 53.2px, times 73.2px, hours 91.1px. The thresholds are those
 * rounded up to whole pixels.
 */

/**
 * Below this the full-size code line (23.04px line + 8px padding + 2px border)
 * does not fit, so the block drops to a compact layout: no vertical padding and
 * a tighter code line, which fits the 20px minimum block height.
 */
export const COMPACT_BELOW_HEIGHT_PX = 34;
/** Padding + code + task name. */
export const NAME_LINE_MIN_HEIGHT_PX = 54;
/** …+ start–end times. */
export const TIMES_LINE_MIN_HEIGHT_PX = 74;
/** …+ hours. */
export const HOURS_LINE_MIN_HEIGHT_PX = 92;

export interface VisibleLines {
  name: boolean;
  times: boolean;
  hours: boolean;
}

export function visibleLines(heightPx: number): VisibleLines {
  return {
    name: heightPx >= NAME_LINE_MIN_HEIGHT_PX,
    times: heightPx >= TIMES_LINE_MIN_HEIGHT_PX,
    hours: heightPx >= HOURS_LINE_MIN_HEIGHT_PX,
  };
}

/** True when even the code line needs the compact layout to avoid being cropped. */
export function isCompactBlock(heightPx: number): boolean {
  return heightPx < COMPACT_BELOW_HEIGHT_PX;
}
